import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";
import type { HTMLAttributes } from "react";

export const CloseButton = (props: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div css={root} {...props}>
      <div className={"CloseButton-background"} css={background} />
      <button className={"CloseButton-trigger"} css={button}>
        <i className={"icon-15-cancel_x"} />
      </button>
    </div>
  );
};

const background = (theme: ExactTheme) => css`
  position: absolute;
  transform-origin: center;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  width: 31px;
  height: 31px;
  border: none;
  padding: 0;

  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  cursor: pointer;
`;

const root = (theme: ExactTheme) => css`
  position: relative;

  //transition: all ease-out 150ms;

  &:hover {
    .CloseButton-trigger {
      background: ${theme.colorsV2.grey[100]};
      color: ${theme.colorsV2.red[500]};
    }
  }
  &:active {
    .CloseButton-trigger {
      background: ${theme.colorsV2.grey[100]};
      color: ${theme.colorsV2.red[700]};
    }
    .CloseButton-background {
      background: ${theme.colorsV2.grey[50]};
      width: 45px;
      height: 45px;
    }
  }
`;

const button = (theme: ExactTheme) => css`
  position: relative;
  cursor: pointer;
  background: transparent;
  width: 31px;
  height: 31px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
`;
